import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route, Router } from '@angular/router';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

  constructor(private siAuthenticationService: SiAuthenticationService, private router: Router) { }

  //  Observable<boolean>
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.siAuthenticationService.authStatus.getValue() &&
      (this.siAuthenticationService.getWebToken() || this.siAuthenticationService.getAuthToken())) {
      return true;
    }
    this.router.navigate(['./login']);
    return false;
  }

  canLoad(route: Route): Observable<boolean> | boolean {
    // Check if user is Authenticated and the Token exists

    if (this.siAuthenticationService.authStatus.getValue() &&
      (this.siAuthenticationService.getWebToken() || this.siAuthenticationService.getAuthToken())) {

      const customerMatch = this.siAuthenticationService.getCustomerList().some(customer => {
        // Since getCustomerList() returns formatted Name e.g. ABC , while the URL has unformatted name e.g.abc
        return this.siAuthenticationService.getUnformattedCustomerName(customer) === route['path'];
      });

      if (customerMatch) {
        // If CustomerList contains the customerName, but is not the activeCustomer
        // And the user is trying to directly modify the URL
        // with a customerName (which is present in CustomerList, but not the active Customer)
        if (this.siAuthenticationService.activeCustomer.getValue() !== route['path']) {
          this.siAuthenticationService.getCustomerList().forEach(customer => {
            if (this.siAuthenticationService.getUnformattedCustomerName(customer) === route['path']) {
              this.siAuthenticationService.setActiveCustomer(customer);
            }
          });
        }
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
